import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Camera, AlertTriangle, Users, Star } from 'lucide-react';

interface SkipPhotosDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirmSkip: () => void;
  photosCount: number;
}

export const SkipPhotosDialog: React.FC<SkipPhotosDialogProps> = ({
  isOpen,
  onClose,
  onConfirmSkip,
  photosCount
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-gradient-to-br from-gray-900 to-black border-white/20 text-white max-w-md w-[calc(100%-2rem)]">
        <DialogHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center">
            <AlertTriangle className="h-8 w-8 text-yellow-500" />
          </div>
          
          <DialogTitle className="text-xl font-bold text-white">
            Seu perfil ficará incompleto
          </DialogTitle>
          
          <DialogDescription className="text-gray-300">
            Perfis com fotos recebem <strong className="text-white">muito mais interações</strong> na plataforma. 
            Você pode continuar sem fotos agora, mas precisará adicionar depois.
          </DialogDescription>
        </DialogHeader>

        {/* Benefícios de ter fotos */}
        <div className="space-y-3 my-4">
          <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg border border-white/10">
            <Users className="h-5 w-5 text-green-400" />
            <p className="text-sm text-gray-200">3x mais visualizações no seu perfil</p>
          </div>
          <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg border border-white/10">
            <Star className="h-5 w-5 text-yellow-400" />
            <p className="text-sm text-gray-200">Maior credibilidade com outros usuários</p>
          </div>
          <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg border border-white/10">
            <Camera className="h-5 w-5 text-blue-400" />
            <p className="text-sm text-gray-200">Perfis completos aparecem primeiro</p>
          </div>
        </div>

        {/* Botões - Prosseguir sem foto PRIMEIRO, cinza */}
        <div className="flex flex-col gap-3 mt-4">
          {/* Botão primário PRIMEIRO - Prosseguir sem foto (cinza) */}
          <Button
            onClick={onConfirmSkip}
            variant="outline"
            className="w-full border-gray-500 bg-gray-800 text-white hover:bg-gray-700"
          >
            Prosseguir sem foto
          </Button>
          
          {/* Botão secundário - Voltar e adicionar (colorido, mais atrativo) */}
          <Button
            onClick={onClose}
            className="w-full bg-gradient-to-r from-[#C4406B] to-[#9F3764] hover:opacity-90 text-white font-semibold"
          >
            <Camera className="h-4 w-4 mr-2" />
            Voltar e adicionar fotos
          </Button>
        </div>

        <p className="text-xs text-gray-500 text-center mt-4">
          Você poderá adicionar fotos depois em Editar Perfil.
        </p>
      </DialogContent>
    </Dialog>
  );
};
